import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Settings() {
  const [biz, setBiz] = useState(null);

  useEffect(() => {
    api.get("/business").then((r) => setBiz(r.data));
  }, []);

  const save = async () => {
    try {
      await api.put("/business", biz);
      toast.success("Business settings saved");
    } catch {
      toast.error("Failed to save");
    }
  };

  if (!biz) return <div className="text-muted-foreground text-sm">Loading…</div>;

  return (
    <div className="space-y-6" data-testid="settings-page">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Business Settings</h1>
        <p className="text-sm text-muted-foreground mt-1">Manage your business profile, GST, and bank details</p>
      </div>

      <Card className="p-6">
        <div className="font-heading font-bold text-lg mb-4">Business Profile</div>
        <div className="grid sm:grid-cols-2 gap-4">
          {[
            ["name", "Business Name"],
            ["gst_number", "GST Number"],
            ["pan_number", "PAN"],
            ["phone", "Phone"],
            ["email", "Email"],
            ["invoice_prefix", "Invoice Prefix"],
            ["logo_url", "Logo URL"],
          ].map(([k, label]) => (
            <div key={k}>
              <Label>{label}</Label>
              <Input value={biz[k] || ""} onChange={(e) => setBiz({ ...biz, [k]: e.target.value })} data-testid={`biz-${k}`} />
            </div>
          ))}
          <div className="sm:col-span-2">
            <Label>Address</Label>
            <Input value={biz.address || ""} onChange={(e) => setBiz({ ...biz, address: e.target.value })} />
          </div>
        </div>
      </Card>

      <Card className="p-6">
        <div className="font-heading font-bold text-lg mb-4">Bank & Payment Details</div>
        <div className="grid sm:grid-cols-2 gap-4">
          {[
            ["bank_name", "Bank Name"],
            ["account_number", "Account Number"],
            ["ifsc", "IFSC Code"],
            ["upi_id", "UPI ID (for QR code on invoices)"],
          ].map(([k, label]) => (
            <div key={k}>
              <Label>{label}</Label>
              <Input value={biz[k] || ""} onChange={(e) => setBiz({ ...biz, [k]: e.target.value })} data-testid={`biz-${k}`} />
            </div>
          ))}
        </div>
      </Card>

      <div className="flex justify-end">
        <Button onClick={save} data-testid="settings-save-btn">Save Changes</Button>
      </div>
    </div>
  );
}
